import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { FormInstance } from 'antd/es/form';
import { get } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components/macro';
import ExtensionAlertModal from 'components/learning/quiz/components/parts/ExtensionAlertModal';
import MembershipInfoModal from 'components/learning/quiz/components/parts/MembershipInfoModal';
import SendingOpinionModal from 'components/learning/quiz/components/parts/SendingOpinionModal';
import { showConfirm } from 'components/modal/showConfirm';
import {
  getQuizDetail,
  createQuiz,
  updateQuiz,
  deleteQuiz,
  gradingQuiz,
  alreadyGradedQuiz,
  checkMenbershipUser,
  getQuizCommentary,
  deleteGradedAnswer,
  getMembershipPaymentDate,
} from 'libs/api/learning';
import { getUrlQuery, showNotification } from 'libs/utils';
import { TQuizbody, TQuizOption, EQuizProcessName, EQuizStep } from 'modules/learning';
import { TQuizAnswer, CQuizStepIndex, TCurrentProcess, TCurrentProcessProps } from 'modules/learning';
import { addDescription, addAnswer, getQuizData } from 'modules/learning/createQuiz';
import { resetState } from 'modules/learning/createQuiz';
import {
  isPageOpenedState,
  currentProcessState,
  gradingLoadingState,
  isGradedState,
} from 'modules/learning/recoilState';
import { TModalState } from 'modules/types';
import { ENotificationType } from 'enums/base.enum';
import { Form, Button, message } from 'antd';
import { device, Colors } from 'GlobalStyles';
import { FormWrapper } from 'GlobalStyles';
import KaitusAssessmentAnswerSheet from './AssessmentAnswerSheet';
import KaitusAssessmentChoiceOption from './AssessmentChoiceOption';
import KaitusAssessmentDescription from './AssessmentDescription';
import KaitusAssessmentHeader from './AssessmentHeader';

const KaitusAssessmentDetail = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const { operation, id } = getUrlQuery(location.search);
  const dispatch = useDispatch();
  //의견 보내기 모달
  const [sendingOpinionModal, setSendingOpinionModal] = useState<TModalState>({
    visible: false,
  });
  //도움말 페이지 오픈 여부
  const [isPageOpened, setIsPageOpened] = useRecoilState<boolean>(isPageOpenedState);
  const [currentProcess, setCurrentProcess] = useRecoilState<TCurrentProcess>(currentProcessState);
  const quizState = useSelector((store: RootState) => store.createQuizReducer);

  const getQuizDetailData = async (id: number) => {
    const { success, data } = await getQuizDetail(id);
    if (success) {
      console.log(`dispatch ++++++++++++`);
      console.log(data);
      dispatch(getQuizData(data));
    }
  };

  useEffect(() => {
    // 수정 페이지 혹은 사용자 뷰일 때
    if (!!id) {
      getQuizDetailData(Number(id));
    }
  }, [id]);

  useEffect(() => {
    if (operation === 'view') {
      dispatch(resetState());
    }
  }, []);

  return (
    <>
      <FormWrapper>
        <Form
          // name="QuizInfo"
          form={form}
          colon={false}
        >
          <KaitusAssessmentHeader form={form} />
          <KaitusAssessmentView form={form} />
        </Form>
      </FormWrapper>
      <SendingOpinionModal modalState={sendingOpinionModal} setModalState={setSendingOpinionModal} />
    </>
  );
};

type TQuizViewProps = {
  form: FormInstance;
};

function KaitusAssessmentView({ form }: TQuizViewProps) {
  const location = useLocation();
  const history = useHistory();
  const { step, step_name, answer_type, operation, id } = getUrlQuery(location.search);
  const dispatch = useDispatch();
  const quizState = useSelector((store: RootState) => store.createQuizReducer);
  const [isLastUpdate, setIsLastUpdate] = useState<{
    updateMode: string;
    isBodyUpdate: boolean;
    isIndexAnswerUpdate: boolean;
  }>({
    updateMode: '',
    isBodyUpdate: false,
    isIndexAnswerUpdate: false,
  });
  const [options, setOptions] = useState<Array<TQuizOption>>([]); //options에서 디폴트뷰만 뺌
  const [defaultAnswer, setDefaultAnswer] = useState<Array<TQuizAnswer>>([]); //quiz_answer에서 is_shown 이 true인 것만
  const [answersExceptDefault, setAnswersExceptDefault] = useState<Array<TQuizAnswer>>([]); //quiz_answer에서 is_shown 이 false인 것만
  const [userAnswer, setUserAnswer] = useState<Array<TQuizOption | TQuizAnswer>>([]); //유저가 선택한 답안
  const [alreadyGradedUserAnswer, setAlreadyGradedUserAnswer] = useState<Array<TQuizAnswer> | null>(); //이미 풀었던 문제의 경우, 푼 문제 정보
  const [membershipInfoModal, setMembershipInfoModal] = useState<TModalState>({
    visible: false,
  });
  const [membershipExtensionModal, setMembershipExtensionModal] = useState<TModalState>({
    visible: false,
  });
  const currentProcess = useRecoilValue<TCurrentProcess>(currentProcessState);
  const [gradingLoading, setGradingLoading] = useRecoilState<boolean>(gradingLoadingState);
  const [isGraded, setIsGraded] = useRecoilState<boolean>(isGradedState);

  //임시저장, 등록 눌렀을 때는 현재step의 문제/해설/선택지/답안지 정보 저장
  const saveQuizDescrtiption = () => {
    const description = form.getFieldValue('description');
    let commentary;

    if (step_name === EQuizStep.SolutionWrapUp) {
      commentary = '<p>해당 문제는 해설을 제공하지 않습니다</p>';
    } else {
      commentary = form.getFieldValue('commentary');
    }

    dispatch(addDescription({ description: description, commentary: commentary }));
  };

  //form을 세팅
  //사용자 등록일 경우 content_number, content, is_shown 다 받아서 포매팅
  //view => 사용자가 푸는 도중(초기 풀기 또는 다시 풀기) => options가 바뀔 때마다 userAnswer에 유저가 선택한 답의 col, depth, content, content_number 등 포매팅해주기위해
  //view => 사용자가 quiz 채점했을 경우 (풀지 못하는 상태)
  const formmatingIndexAnswerForm = () => {
    const formState = form.getFieldsValue();

    let newIndexAnswerState: Array<TQuizAnswer> = [];
    const keysArr = Object.keys(formState);
    //index answer과 관련없는 값들은 빼기, index answer과 관련있는 값들 중에서도 is_shown 이나 number말고 index_answer_{col}_{depth} 만 남도록
    //일단은 현재 있는 값들의 colum_index, depth 값들을 뽑아내기 위한 과정이기 때문에
    const filterIndexAnswerKey = keysArr.filter(
      (el: string) => el.split('_')[0] === 'index' && el.split('_').length === 4,
    );

    filterIndexAnswerKey.map((el: string) => {
      const splitedkey = el.split('_');
      const column_index = Number(splitedkey[2]);
      const depth = Number(splitedkey[3]);
      let indexAnswerElement;
      if (operation !== 'view') {
        indexAnswerElement = {
          column_index: column_index,
          depth: depth,
          parent: null, //수정 필요
          content: formState[`index_answer_${column_index}_${depth}`],
          content_number: formState[`index_answer_number_${column_index}_${depth}`],
          is_shown: formState[`index_answer_is_shown_${column_index}_${depth}`],
          id: formState[`index_answer_id_${column_index}_${depth}`],
        };
      }
      if (operation === 'view' && quizState.options) {
        const formValueId = formState[`index_answer_${column_index}_${depth}`];
        const pickAtOptions = quizState.options.find((el: TQuizOption) => el.id === formValueId);
        if (pickAtOptions) {
          indexAnswerElement = {
            id: formValueId,
            content: pickAtOptions.content,
            content_number: pickAtOptions.content_number,
            column_index: column_index,
            depth: depth,
            parent: null, //수정 필요
            is_shown: false,
          };
        }
      }
      if (indexAnswerElement) {
        newIndexAnswerState.push(indexAnswerElement);
      }
    });

    return newIndexAnswerState;
  };

  const saveIndexAnswerState = () => {
    dispatch(addAnswer('index', formmatingIndexAnswerForm()));
  };

  //등록하기 버튼 => id가 있으면 {id}값 넣어서 put으로 보내기 / id가 없으면 초기 생성이므로 post
  const createPostAsync = async () => {
    //3 post
    if (!!id) {
      const { success, data, error } = await updateQuiz(
        {
          ...quizState,
          is_completed: isLastUpdate.updateMode === 'create', //'create'이면 is_completed:true, 'save'이면  is_completed:false
        },
        Number(id),
      );
      if (success) {
        if (isLastUpdate.updateMode === 'create') {
          history.push('/case/quizzes');
        } else if (isLastUpdate.updateMode === 'save') {
          window.location.replace(
            `/case/quiz/create/${id}?step=${step}&step_name=${step_name}&answer_type=${answer_type}`,
          );
        }
      } else {
        message.error('필수 입력 사항을 모두 입력해주세요');
        error?.field_errors.forEach((el: any) => message.error(`${el.name} ${el.message}`));
      }
    } else {
      const { success, data, error } = await createQuiz({
        ...quizState,
        is_completed: isLastUpdate.updateMode === 'create', //'create'이면 is_completed:true, 'save'이면  is_completed:false
      });
      if (success) {
        if (isLastUpdate.updateMode === 'create') {
          history.push('/case/quizzes');
        } else if (isLastUpdate.updateMode === 'save') {
          const getId = get(data, 'id');
          const getStepName = get(data, 'quiz_type');
          const getAnswerType = get(data, 'answer_type');
          window.location.replace(
            `/case/quiz/create/${getId}?step=${CQuizStepIndex[getStepName]}&step_name=${getStepName}&answer_type=${getAnswerType}`,
          );
        }
      } else {
        message.error('필수 입력 사항을 모두 입력해주세요');
        error?.field_errors.forEach((el: any) => message.error(`${el.name} ${el.message}`));
      }
    }
  };

  //등록하기 버튼 => id가 있으면 {id}값 넣어서 put으로 보내기 / id가 없으면 초기 생성이므로 post로 보내기
  const onClickCreateQuiz = async ({ clicked }: { clicked: string }) => {
    // clicked =>'create' or 'save'
    setIsLastUpdate((prev) => {
      return { ...prev, updateMode: clicked }; //등록인지 임시저장인지 확인
    });

    saveQuizDescrtiption(); //1
    setIsLastUpdate((prev) => {
      return { ...prev, isBodyUpdate: true };
    });

    if (answer_type === 'index') {
      saveIndexAnswerState(); //2
      setIsLastUpdate((prev) => {
        return { ...prev, isIndexAnswerUpdate: true };
      });
    } else {
      setIsLastUpdate((prev) => {
        return { ...prev, isIndexAnswerUpdate: true };
      });
    }
  };

  //삭제하기 버튼
  const onClickDeleteQuiz = async () => {
    const { success } = await deleteQuiz(Number(id));
    if (success) {
      history.push({
        pathname: '/case/quizzes',
        state: {
          notification: {
            type: ENotificationType.Success,
            message: '문제가 삭제되었습니다.',
          },
        },
      });
    }
  };

  //view ==> 초기화를 누르거나 푼 문제를 다시풀기 눌렀을 때 이니셜 정보를 세팅해줌
  const settingInitialOptionsAndAnswer = () => {
    //디폴트 추출
    const isShownList = quizState.quiz_answer.filter((el: TQuizAnswer) => el.is_shown === true);
    const isShownListIds = isShownList.map((el: TQuizAnswer) => el.id);
    //디폴트 제외한 옵션 리스트 : 디폴트 리스트에서 id값만 추출한 배열과 비교해서 options에서 디폴트 빼주기 (실제 옵션 리스트)
    const optionsExceptDefault = quizState.options?.filter(
      (el: TQuizOption) => !isShownListIds.includes(el.id),
    );
    //디폴트 제외한 답변 리스트 :
    const answerExceptDefault = quizState.quiz_answer.filter(
      (el: TQuizAnswer) => !isShownListIds.includes(el.id),
    );
    setDefaultAnswer(isShownList);
    setAnswersExceptDefault(answerExceptDefault);
    if (optionsExceptDefault) {
      setOptions(optionsExceptDefault);
    }
  };

  const checkMenbership = async () => {
    const { success, data } = await checkMenbershipUser();
    if (success) return data.message;
  };

  //멤버십 유저일 경우 해설 받아주기
  const getCommentary = async () => {
    const { data } = await getQuizCommentary(Number(id));
    const questionBody = quizState.quiz_body.find((el: TQuizbody) => !el.is_explanation)?.body;
    if (questionBody)
      dispatch(
        addDescription({
          description: questionBody,
          commentary: data.body,
        }),
      );
  };

  const isExtensionAlertShown = async () => {
    try {
      const { data } = await getMembershipPaymentDate();
      //결제 날짜가 들어온다는 것은 ==> 만료된 사람이 채점하기 눌렀을 때 1번 미만인 사람
      if (data) return true;
      return false;
    } catch (e) {
      throw e;
    }
  };

  //채점하기 버튼
  const onClickGradingQuiz = async () => {
    if (quizState.quiz_type === EQuizStep.SolutionWrapUp) {
      //채점기능을 제공하지 않는 문제입니다.
      message.info('채점기능을 제공하지 않는 문제입니다.');
    } else {
      setGradingLoading(true);
      //멤버십 유저인지 체크
      checkMenbership().then(async (value) => {
        //멤버십유저이거나 샘플문제이면채점되도록
        if (value || quizState.is_sample) {
          //멤버십 유저일 경우 해설 받아주기
          //getCommentary();

          let formattedUserAnswer;
          //리스트 유형
          if (quizState.answer_type === 'list') {
            formattedUserAnswer = userAnswer.map((x: TQuizOption) => {
              const correctAnswerIds = quizState.quiz_answer.map((y: TQuizAnswer) => y.id);
              if (!correctAnswerIds.includes(x.id)) {
                return {
                  ...x,
                  parent: null,
                  column_index: null,
                  depth: null,
                  is_shown: false,
                };
              } else {
                return quizState.quiz_answer.find((z: TQuizAnswer) => z.id === x.id);
              }
            });
          }
          //목차 유형
          if (quizState.answer_type === 'index') {
            formattedUserAnswer = userAnswer;
          }

          console.log(formattedUserAnswer)
          console.log(defaultAnswer)
 
          if (formattedUserAnswer && formattedUserAnswer.length > 0) {
            try {
              setTimeout(() => {
                setGradingLoading(false);
              }, 2000);
              const { success, data } = await gradingQuiz({
                quiz_id: quizState.id,
                answers: [...formattedUserAnswer, ...defaultAnswer], //내가 선택한 답지와 디폴트 답안을 합해서 보내야함
              });
              if (success) {
                showNotification('success', '성공적으로 답안을 제출하였습니다.');
              }
            } catch (e) {
              throw e;
            } finally {
            }
          } else {
            setGradingLoading(false);
            showNotification('success', '선택된 답안이 없습니다.');
            return
          }

          //채점하기 누르고 바로 path 변경됐을 경우
          setIsGraded(true);
          getAlreadyGradedQuizAnswer(); // 초기 채점이거나 or 다시 풀기 해서 채점했을 경우에 바로 채점 -> 유저가 푼 정보 들어오도록
        } else {
          setGradingLoading(false);

          isExtensionAlertShown().then((value) => {
            if (value) {
              //만료된 사람 && 결제 날짜에 대한 값이 들어오고 && 채점하기 클릭 횟수가 1미만 ==> 만료 후 연장 모달
              setMembershipExtensionModal({ visible: true });
            } else {
              //결제한적이 없거나 만료 || 만료되고 클릭 횟수가 1이상 ==> 멤버십 가입 안내 모달
              setMembershipInfoModal({
                visible: true,
              });
            }
          });
        }
      });
    }
  };

  //view ==> 초기화 버튼
  const onClickResetAnswer = () => {
    settingInitialOptionsAndAnswer();
    setUserAnswer([]);
    form.resetFields();
  };

  const onClickSolveAgain = async () => {
    setIsGraded(false);
    onClickResetAnswer();
    const { success, data } = await deleteGradedAnswer(Number(id));
  };

  //view
  const getAlreadyGradedQuizAnswer = async () => {
    const { success, data } = await alreadyGradedQuiz(Number(id));
    if (success) {
      setIsGraded(data.is_solved);
      data.is_solved && setAlreadyGradedUserAnswer(data.answer); //setState
    }
  };

  //view => 풀었던 유저의 히스토리 받아주기
  useEffect(() => {
    if (isGraded && alreadyGradedUserAnswer) {
      const defaultList = alreadyGradedUserAnswer.filter((el: TQuizAnswer) => el.is_shown === true);
      const prevUserAnswer = alreadyGradedUserAnswer.filter((el: TQuizAnswer) => el.is_shown === false);
      const answerIds = alreadyGradedUserAnswer.map((el: any) => el.id);
      const filteredOptions = quizState.options?.filter((el: TQuizOption) => !answerIds.includes(el.id));
      // 디폴트 제외한 답변 리스트 :
      const defaultIds = defaultList.map((el: TQuizAnswer) => el.id);
      const answerExceptDefault = quizState.quiz_answer.filter(
        (el: TQuizAnswer) => !defaultIds.includes(el.id),
      );

      setDefaultAnswer(defaultList);
      setUserAnswer(prevUserAnswer);
      filteredOptions && setOptions(filteredOptions);
      answerExceptDefault && setAnswersExceptDefault(answerExceptDefault);
    }
  }, [alreadyGradedUserAnswer]);

  useEffect(() => {
    if (operation === 'view') {
      //view => 유저가 풀었던 답안 리스트를 받아줌
      if (quizState.id) {
        getAlreadyGradedQuizAnswer();
      }
    }
  }, [quizState.id]);

  useEffect(() => {
    if (operation === 'view') {
      //view => 풀지 않았던 문제 => 이전에 채점되었던 적이 없었던것이므로 Initial Option 과 Answer 받아주기
      if (quizState.id === Number(id) && !isGraded && !alreadyGradedUserAnswer) {
        settingInitialOptionsAndAnswer();
      }
    }
  }, [quizState.id, isGraded, alreadyGradedUserAnswer]);

  useEffect(() => {
    if (operation === 'view') {
      //풀었던 이력이 있으면 지금도 멤버십인지 확인하고 해설 세팅해주기
      if (isGraded && quizState.id && alreadyGradedUserAnswer) {
        checkMenbership().then(async (value) => {
          if (value || quizState.is_sample) {
            getCommentary();
          }
        });
      }
    }
  }, [isGraded, alreadyGradedUserAnswer]);

  //사용자가 문제 등록할 경우
  useEffect(() => {
    if (isLastUpdate.isBodyUpdate && isLastUpdate.isIndexAnswerUpdate) {
      createPostAsync();
      setIsLastUpdate({
        updateMode: '',
        isBodyUpdate: false,
        isIndexAnswerUpdate: false,
      });
    }
  }, [isLastUpdate]);

  //view => 기존에 풀었던 답안을 form에 세팅
  const setFormFieldsPrevUserAnswer = () => {
    const formFields = userAnswer.map((answer: any) => {
      const formField = {
        name: `index_answer_${answer.column_index}_${answer.depth}`,
        value: answer.id,
      };
      return formField;
    });
    form.setFields(formFields);
    setUserAnswer([...userAnswer]); // 해당 form, item에 들어있는 옵션만 그 form 옵션 리스트에 추가하는 로직이 userAnswer를 의존성 배열로 가지고 있기 때문에
  };

  //view => 문제 풀 때 수시로 사용자 답안 저장해주기 && 자기가 풀었던 풀이 form에 다시 저장해주기
  //목차 유형 옵션과 유저 정답지 세팅 - 2. 유저 정답지 세팅
  //목차유형에서는 선택할 때마다 form value에 따라서 option 필터링해주기 때문에 options를 deps로 해서 userAnswer를 세팅해준다
  useEffect(() => {
    if (quizState.answer_type === 'index' && operation === 'view') {
      if (!isGraded) {
        //view => 사용자가 푸는 도중(초기 풀기 또는 다시 풀기) => options가 바뀔 때마다 userAnswer에 유저가 선택한 답 포매팅해주기위해
        setUserAnswer(formmatingIndexAnswerForm());
      } else if (isGraded) {
        //view => 사용자가 quiz 채점했을 경우 (풀지 못하는 상태)
        setFormFieldsPrevUserAnswer();
      }
    }
  }, [options]);

  useEffect(() => {
    if (operation === 'view') {
      //이전 다음 클릭해서 id 바뀔때마다 상태값 초기화시켜주기
      setOptions([]);
      setDefaultAnswer([]);
      setAnswersExceptDefault([]);
      setUserAnswer([]);
      setAlreadyGradedUserAnswer(null);
    }
    setIsGraded(false);

    //목차 유형 답지 일 때 폼 reset
    form.resetFields();
  }, [id]);

  return (
    <QuizDetailWrapper id='popper_boundary'>
      <StyledQuizMain>
        <section className='descriptionWrapper'>
          <KaitusAssessmentDescription form={form} />
        </section>
        <section className='optionAndAnswerWrapper'>
          <KaitusAssessmentChoiceOption
            form={form}
            options={options}
            setOptions={setOptions}
            answersExceptDefault={answersExceptDefault}
            setAnswersExceptDefault={setAnswersExceptDefault}
            userAnswer={userAnswer}
            setUserAnswer={setUserAnswer}
          />
          <KaitusAssessmentAnswerSheet
            form={form}
            options={options}
            setOptions={setOptions}
            answersExceptDefault={answersExceptDefault}
            setAnswersExceptDefault={setAnswersExceptDefault}
            defaultAnswer={defaultAnswer}
            setDefaultAnswer={setDefaultAnswer}
            userAnswer={userAnswer}
            setUserAnswer={setUserAnswer}
          />
        </section>
      </StyledQuizMain>
      {operation === 'view' ? (
        <StyledBottomButtons style={{ justifyContent: 'space-between' }}>
          {isGraded && !gradingLoading ? (
            <StyledBtnWrapper style={{ justifyContent: 'start' }}>
          </StyledBtnWrapper>
          ) : (
            <StyledBtnWrapper style={{ justifyContent: 'start' }}>
              {quizState.quiz_type !== EQuizStep.SolutionWrapUp && (
                <Button
                  className='large'
                  onClick={onClickResetAnswer}
                  //막혀있어야 하는 경우 ==> isGraded가 true
                  disabled={isGraded}
                >
                  선택된 답안들 초기화
                </Button>
              )}
            </StyledBtnWrapper>
            )}
          {isGraded && !gradingLoading ? (
            <StyledBtnWrapper
              style={{ justifyContent: 'end' }}
              id={`${EQuizProcessName.GradingButton}_popper_reference`}
              currentProcess={currentProcess.name === EQuizProcessName.GradingButton}
            >
              <Button
                className='secondary large'
                onClick={onClickSolveAgain}
                // disabled={gradingLoading}
              >
                문제 다시풀기
              </Button>
            </StyledBtnWrapper>
          ) : (
            <StyledBtnWrapper
              style={{ justifyContent: 'end' }}
              id={`${EQuizProcessName.GradingButton}_popper_reference`}
              currentProcess={currentProcess.name === EQuizProcessName.GradingButton}
            >
              {quizState.quiz_type !== EQuizStep.SolutionWrapUp && (
                <Button
                  className='ant-btn-primary large'
                  onClick={() => {
                    onClickGradingQuiz();
                    // setSolveAgain(false);
                  }}
                  loading={gradingLoading} //채점하는 동안은 버튼 로딩걸리도록
                >
                  선택된 답안 저장
                </Button>
              )}
            </StyledBtnWrapper>
          )}
        </StyledBottomButtons>
      ) : (
        <>
          <StyledBottomButtons style={{ justifyContent: 'end', padding: '30px' }}>
            {!!id && (
              <Button
                onClick={() => showConfirm(() => onClickDeleteQuiz(), '문제를 삭제하시겠습니까?')}
                style={{ marginRight: '10px' }}
                className='ant-btn-dangerous large'
              >
                삭제하기
              </Button>
            )}
            <Button
              onClick={() => onClickCreateQuiz({ clicked: 'save' })}
              style={{ marginRight: '10px' }}
              className='large'
            >
              임시 저장
            </Button>
            <Button
              onClick={() => onClickCreateQuiz({ clicked: 'create' })}
              className='ant-btn-primary large'
            >
              등록하기
            </Button>
          </StyledBottomButtons>
        </>
      )}
      {operation === 'view' && (
        <MembershipInfoModal modalState={membershipInfoModal} setModalState={setMembershipInfoModal} />
      )}
      {operation === 'view' && (
        <ExtensionAlertModal
          modalState={membershipExtensionModal}
          setModalState={setMembershipExtensionModal}
        />
      )}
    </QuizDetailWrapper>
  );
}

export default KaitusAssessmentDetail;

const QuizDetailWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;

  & .ant-tabs-tab {
    padding: 12px 15px;
  }

  & .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 0;
  }
  & .ant-tabs-tab + .ant-tabs-tab {
    margin: 0px;
  }
`;

const StyledQuizMain = styled.main`
  display: flex;
  margin: 0 20px;
  & .ant-tabs-tab-btn {
    padding: 0px 15px;
  }
  & .descriptionWrapper {
    width: 40%;
  }
  & .optionAndAnswerWrapper {
    width: 60%;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
    & .descriptionWrapper {
      width: unset;
    }
    & .optionAndAnswerWrapper {
      width: unset;
    }
  }
`;

const StyledTopButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 20px 20px;
  & .ant-btn {
    margin-right: 10px;
  }
`;

const StyledBottomButtons = styled.div`
  display: flex;
`;

const StyledBtnWrapper = styled.div<TCurrentProcessProps>`
  display: flex;
  /* width: 50%; */
  padding: 30px 20px;
  //💜 도움말에서 해당 파트일 때
  ${(props) => props.currentProcess && 'height: 104px;'}
  ${(props) => props.currentProcess && 'width: 40%;'}
  ${(props) => props.currentProcess && 'z-index: 90;'}
  position: relative;
  background-color: ${Colors.white};
  @media screen and ${device.sm} {
    ${(props) => props.currentProcess && 'z-index: unset;'}
  }
`;
